export default class PossibleProducerAgent {

	public id: number | null = null;
	public firstName: string | null = null;
	public lastName: string | null = null;
	public username: string | null = null;
	public groupAuthority: string | null = null;
	public displayName: string | null = null;

	public constructor() {

	}
};